export const BUTTON_SINGLE = "buttonSingle";
export const BUTTON_MENU = "buttonMenu";
export const BUTTON_SHOWTIME = "buttonShowtime";
export const BUTTON_PARTAGE = "buttonPartage";
export const BUTTON_RESERVER = "buttonReserver";
export const BUTTON_THEATER_PHONE = "buttonTheaterPhone";
export const BUTTON_FLOAT = "buttonFloat";
export const BUTTON_ICON = "buttonIcon";
export const BUTTON_PLUS = "buttonPlusSeance";
export const BUTTON_SELECT_VIDEO = "buttonSelectVideo";
export const BUTTON_PLAY_VIDEO = "buttonPlayVideo";
export const SELECT_SEANCE = "seanceSelect";
export const BUTTON_CLOSE_SHOWTIME_MODAL = "buttonCloseShowtimeModal";
export const BUTTON_TYPEFORM = "buttonTypeform";

export const IMAGE_AFFICHE = "imageAffiche";
export const IMAGE_GALLERY = "imageGallery";
export const DATE = "date";
export const CRITIQUE = "critique";
export const SHARE = "share";
export const BOOK = "book";
export const SEARCH = "search";
export const SE_LOCALISER = "seLocaliser";
export const CLICK = "Click";
export const SLIDE = "Slide";
export const SCROLL = "Scroll";
export const MORE_REVIEW = "moreReview";
export const MORE_SEANCES = "moreSeances";
export const FIRST_SCROLL_INFOS = "firstScrollInfos";
export const FIRST_SCROLL_SEANCES = "firstScrollSeances";
export const UNLOAD = "unload";
export const VIDEO = "video";
export const VIDEO_START = "videoStart";
export const VIDEO_PROGRESS = "videoProgress";
export const VIDEO_PAUSE = "videoPause";
export const SHOWTIMES_INTEREST = "showtimesInterest";
export const REVIEWS_INTEREST = "reviewsInterest";
export const REVIEW_LINK = "reviewLink";
export const BANNER = "banner";
